module.exports = __webpack_public_path__ + "static/media/talking-with-your-partner.ae7bda4d.svg";